import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel } from '@/models';
import { elkLog } from '@/utils/elkReport';

export interface WhiteboardPermissionResp {
  permission: number;
}

export default function useWhiteboardPermission() {
  const { meeting } = useLocalStore(() => {
    return {
      meeting: meetingModel,
    };
  });

  const setWhiteboardPermission = async (body: WhiteboardPermissionResp) => {
    const { permission } = body;
    meeting.setwbEnablePermission(permission);
    elkLog('收到白板权限变更通知', body);
  };

  return setWhiteboardPermission;
}
